import { EnvironmentProviders, inject, Provider } from '@angular/core';
import { DeveloperService, SOFTLINE_CONFIG_SETTINGS } from '@softline/application';
import {
  SOFTLINE_CONFIG_TEST_CONNECTION_PATH,
  SOFTLINE_SERVICE_TEST_CONNECTION,
  SOFTLINE_SETTINGS_CONNECTION
} from './connection-settings.shared';
import { ConnectionSettingsComponent } from './components/connection-settings.component';
import { TestConnectionService } from './services/test-connection.service';
import { toObservable } from '@angular/core/rxjs-interop';

export const connectionSettingsProviders: Array<Provider | EnvironmentProviders> = [
  {
    provide: SOFTLINE_SERVICE_TEST_CONNECTION,
    useClass: TestConnectionService,
  },
  { provide: SOFTLINE_CONFIG_TEST_CONNECTION_PATH, useValue: '/v1/test' },
  {
    provide: SOFTLINE_CONFIG_SETTINGS,
    multi: true,
    useFactory: () => {
      const developerService = inject(DeveloperService);
      return {
        key: SOFTLINE_SETTINGS_CONNECTION,
        component: ConnectionSettingsComponent,
        title: '#CONNECTION_SETTINGS.TITLE',
        default: undefined,
        icon: 'fa-regular fa-link',
        visible: toObservable(developerService.isDeveloper)
      }
    }
  },
];
